import { useState } from 'react'
import { Alert, Box } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'

import useCsrfToken from '@/hooks/useCsrfToken'

import Container from '@/Components/Layout/Container'
import { activateAccount } from '@/Components/Pages/Accounts/actions'
import FormFields from '@/Components/Pages/Accounts/FormFields'
import Card from '@/Components/Pages/Login/Card'
import CardHeader from '@/Components/Pages/Login/CardHeader'

type ActivationPageProps = {
  first_name: string
  last_name: string
  email: string
  invitation_token: string
}

const ActivationPage: React.FC<ActivationPageProps> = ({
  invitation_token,
  ...defaultValues
}) => {
  const [error, setError] = useState<string | null>(null)
  const csrfToken = useCsrfToken()
  const methods = useForm<
    ActivationPageProps & { password: string; password_confirmation: string }
  >({
    defaultValues
  })
  const { handleSubmit } = methods

  const onSubmit = async (
    data: ActivationPageProps & {
      password: string
      password_confirmation: string
    }
  ) => {
    const response = await activateAccount({
      token: invitation_token,
      user: data,
      csrfToken
    })
    if (response.error) {
      setError(response.error)
      return
    }
    window.location.href = '/'
  }

  return (
    <Container sx={{ pb: 8 }}>
      <Card>
        <CardHeader title="Activate Account" />
        {error && <Alert>{error}</Alert>}
        <FormProvider {...methods}>
          <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <FormFields />
          </Box>
        </FormProvider>
      </Card>
    </Container>
  )
}

export default ActivationPage
